export const removeWhiteSpace = (string) => {
	return string.replace(/ /g, "");
};
